import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { AuthContext } from "./AuthContext";
import { fetchSetupProgress } from "../../services/setupProgressService";
import { queryClient } from "../../lib/queryClient";

export const SetupProgressContext = createContext(null);

function isStaff(role) {
  const r = String(role || "").toLowerCase();
  return r === "admin" || r === "hr" || r === "superadmin" || r === "super_admin";
}

export default function SetupProgressProvider({ children }) {
  const { role } = useContext(AuthContext);
  const [progress, setProgress] = useState({
    loading: true,
    items: [],
    percent: 0,
    payrollReady: false,
    orgProfileComplete: false,
    alerts: [],
  });

  const refetch = useCallback(async ({ fresh = true } = {}) => {
    if (!isStaff(role)) {
      setProgress((p) => ({ ...p, loading: false }));
      return;
    }
    if (fresh) {
      await queryClient.invalidateQueries({
        predicate: (query) =>
          ["setup-status", "wf-setup-status", "org-profile-status", "organisation-me"].includes(
            query.queryKey?.[0]
          ),
      });
    }
    setProgress((p) => ({ ...p, loading: true }));
    try {
      const data = await fetchSetupProgress();
      setProgress({ ...data, loading: false });
    } catch {
      setProgress((p) => ({ ...p, loading: false }));
    }
  }, [role]);

  useEffect(() => {
    refetch({ fresh: false });
  }, [refetch]);

  return (
    <SetupProgressContext.Provider value={{ progress, refetch }}>
      {children}
    </SetupProgressContext.Provider>
  );
}

export function useSetupProgress() {
  return useContext(SetupProgressContext);
}
